import { Chip } from "@mui/material";
import { AtTagAccountsProps, AtTagAccountsStatus } from "../at-tag.types";

export const TagAccounts = ({ status }: AtTagAccountsProps) => {
  const { color, backgroundColor } = getColor(status);
  const text = getLabel(status);

  return (
    <Chip
      label={text}
      className={`!text-xs !font-semibold px-4 ${backgroundColor} ${color}  min-w-[103px]`}
    />
  );
};

const getLabel = (status: AtTagAccountsStatus) => {
  switch (status) {
    case AtTagAccountsStatus.ACTIVE:
      return "Activado";
    case AtTagAccountsStatus.INACTIVE:
      return "Desactivado";
  }
};

const getColor = (status: AtTagAccountsStatus) => {
  switch (status) {
    case AtTagAccountsStatus.ACTIVE:
      return {
        color: "!text-success-800",
        backgroundColor: "!bg-success-75",
        // width: "w-[98px]",
      };
    case AtTagAccountsStatus.INACTIVE:
      return {
        color: "!text-surface-400",
        backgroundColor: "!bg-surface-50",
        // width: "w-[99px]",
      };
  }
};
